import { CameraType } from '@EcamModel/controllers/ICameraHttpController';
import { Box } from '@mui/material';
import { useCameraDetailContext } from '@pages/cameras/hook/CameraDetailsProvider';
import color from '@theme/Colors';
import GeoZonesOverViewPTZ from './ptz';
import GeoZonesDetailSolar from './solar';
import GeoZonesOverViewSP111 from './sp111';

export default function GeoZonesTabs() {
    const { camera } = useCameraDetailContext();
    return (
        <Box bgcolor={color.white} padding={2} border={`1px solid #DDDDDD`} borderRadius={'0px 8px 8px 8px'}>
            {camera.PTZCameraId !== null ? (
                <GeoZonesOverViewPTZ />
            ) : camera.SP111CameraId !== null ? (
                <GeoZonesOverViewSP111 />
            ) : (
                <GeoZonesDetailSolar
                    cameraType={camera.VendorCameraId !== null ? CameraType.Solar : CameraType.PMC8266}
                />
            )}
        </Box>
    );
}
